import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `movimientoVerraco/checkUbicacionVerracoFecha`, method: 'POST', body: values, token: token})
}
